import SearchService from './common/services/SearchService'
// import _ from 'lodash'

const Search = new SearchService();

let timeout;
const debounce = function (func, delay, context) {
    return function () {
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(function () {
            func.apply(null, context);
        }, delay);
    }();
};

$(document).on('turbo:load turbo:render', () => {
    let $searchElements = $("div[data-search-field]");
    if ($searchElements.length) {
        $searchElements.each((ind, el) => {
            let $el: JQuery = $(el);

            registerSearch($el);
            registerFocusOut($el);
            registerClear($el);
        })
    }

    function registerSearch($el) {
        let $input: JQuery = $el.find("input[type='text']");
        $input.on('input', (event)=> {
            let $input = $(event.target);
            let $list: JQuery = $el.find('.search-list');
            let type: string = $el.data('search-field');
            let extra_type: string = $el.data('extra-search-field');
            let isActive: boolean = $el.data('is-active');
            let searchVal: string = $input.val() as string;
            let $idInput: JQuery = $input.prev('input[type="hidden"]');
            if (searchVal.length >= 2) {
                debounce(getResults, 500, [$input, $list, $idInput, searchVal, type, extra_type, isActive])
            } else if (searchVal.length == 0) {
                $el.find(".search-box").parent('div').first().next('div').show()
            }
            else $list.children().remove();
        });

    }

    function registerClear($el) {
        let $button: JQuery = $el.find('button.btn-link');
        $button.on('click', (event) => {
            let $input: JQuery = $el.find("input[type='text']");
            let $list: JQuery = $el.find('.search-list');
            event.preventDefault();
            clearSearch($el, $input, $list);
        });
    }

    function clearFields($el) {
        let $input: JQuery = $el.find("input[type='text']");
        let $list: JQuery = $el.find('.search-list');
        clearSearch($el, $input, $list);
    }

    function registerFocusOut($el) {
        let $input: JQuery = $el.find("input[type='text']");
        $input.on('change, focusout', (event)=> {
            let $list: JQuery = $el.find('.search-list');
            let searchVal: string = $input.val() as string;
            let $items: JQuery = $list.find('li');
            if ($items.length > 0) {
                if ($items.length == 1 && $($items[0]).text() == searchVal) {
                    $items.trigger('mousedown');
                } else {
                    clearSearch($el, $input, $list)
                }
                setTimeout(callback, 300);
            } else if ($items.length < 1 && searchVal.length > 0) {
                clearSearch($el, $input, $list)
            }
            function callback() {
                $list.children().remove();
            }
        });
    }

    function clearSearch($el, $input, $list) {
        $input.val('');
        $list.children().remove();
        clearId($el);
    }

    function clearId($el) {
        let $idInput: JQuery = $el.find("input[type='hidden']");
        if ($idInput.length) {
            $idInput.val('');
        }
    }

    async function getResults($input, $list, $idInput, searchVal, type, extra_type, isActive) {

        const response = await Search.getResults(searchVal, type, extra_type, isActive);
        if (response && response.result === 'success') {
            $list.children().remove();
            let results: Array<any> = response.message;
            if (results.length) {
                $list.append('<ul></ul>');
                results.forEach((i) => {
                    let str = `<li id='${i._id}'>${i.name}</li>`;
                    let $item = $(str);
                    $list.find('ul').append($item);
                    $list.find($item).on('mousedown', (event) => {
                        $list.children().remove();
                        $input.val(i.name);
                        if ($idInput.length) {
                            $idInput.val(i._id);
                        }
                    });
                });
            }
        }
        else $list.children().remove();
    }
});







